/**
 * Transport - Gestion du BPM, play/stop, sync
 */

import * as Tone from 'tone';

export class Transport {
    constructor() {
        this._bpm = 120;
        this._isPlaying = false;
        this._swing = 0; // 0 = no swing, 1 = max swing

        // Initialiser le BPM
        Tone.Transport.bpm.value = this._bpm;

        // Initialiser le swing (appliqué aux 16th notes)
        Tone.Transport.swing = this._swing;
        Tone.Transport.swingSubdivision = '16n';
    }

    /**
     * Démarre ou arrête le transport
     */
    async toggle() {
        if (!this._isPlaying) {
            await Tone.start();
            Tone.Transport.start();
            this._isPlaying = true;
        } else {
            Tone.Transport.stop();
            this._isPlaying = false;
        }
        return this._isPlaying;
    }

    /**
     * Démarre le transport
     */
    async start() {
        if (!this._isPlaying) {
            await Tone.start();
            Tone.Transport.start();
            this._isPlaying = true;
        }
    }

    /**
     * Arrête le transport
     */
    stop() {
        if (this._isPlaying) {
            Tone.Transport.stop();
            this._isPlaying = false;
        }
    }

    /**
     * Définit le BPM
     * @param {number} value - BPM (60-180)
     */
    setBpm(value) {
        this._bpm = Math.max(60, Math.min(180, value));
        Tone.Transport.bpm.value = this._bpm;
    }

    get bpm() {
        return this._bpm;
    }

    /**
     * Définit le swing (shuffle)
     * @param {number} value - Swing 0-1 (0 = straight, 1 = max swing)
     */
    setSwing(value) {
        this._swing = Math.max(0, Math.min(1, value));
        Tone.Transport.swing = this._swing;
    }

    get swing() {
        return this._swing;
    }

    get isPlaying() {
        return this._isPlaying;
    }

    /**
     * Obtient le temps actuel pour synchronisation
     */
    get now() {
        return Tone.now();
    }

    /**
     * Planifie une callback sur le Draw scheduler (pour UI sync)
     */
    scheduleRepeat(callback, interval) {
        return Tone.Transport.scheduleRepeat(callback, interval);
    }
}
